import crud from './helpers/crud';

const patientSplitRequest = (fileToken, signal, actionName) => crud({
  method: 'get',
  url: `/api/v1/records/${encodeURIComponent(fileToken)}/patient_split`,
  signal,
  // Polling owns retries; immediately clear stale links on a failed refresh.
  retryOnUnavailable: false,
  dispatch: {
    begin: `BEGIN_${actionName}`,
    end: `FINISHED_${actionName}`,
    fail: `FAILED_${actionName}`,
    meta: { fileToken },
  },
});

const getPatientSplit = (fileToken, signal) => patientSplitRequest(fileToken, signal, 'GET_PATIENT_SPLIT');
// Inbox previews must not update the active viewer's permissions or relationship state.
export const getPatientSplitPreview = (fileToken, signal) => patientSplitRequest(fileToken, signal, 'GET_PATIENT_SPLIT_PREVIEW');

export default getPatientSplit;
